import React from 'react';

const Shows: React.FC = () => {
  return (
    <section className="page shows">
      <div className="container">
        <h2>Shows</h2>

        <article className="current-show">
          <h3>This Was Supposed To Be Fun</h3>
          <span className="show-status">In Development</span>
          <div className="show-description">
            <p>
              On the first night of her honeymoon, Colleen Lavin got laid off from her tech job on a mass Zoom call. Even worse, the swim-up bar was already closed for the night.
            </p>
            <p>
              In <em>This Was Supposed To Be Fun</em>, Colleen explores the stagnant nature of post-AI culture, the absurd trivialities of wedding planning, and the decline of worker standards across industries. She also asks the important questions, like: when did everyone start playing pickleball? Why does her toothbrush now have a subscription tier? And under what circumstances should you complete a job application from a hot tub without telling your spouse?
            </p>
            <p>
              Against the backdrop of a meticulously planned honeymoon, Colleen tries to work out what went wrong. Was it ambition? Burnout? The belief that if you just optimise your life enough, nothing bad can happen to you? Drawing on her experience inside the tech industry, she takes a close look at modern work culture, productivity, and the quiet panic of realising your entire sense of self might be a LinkedIn headline.
            </p>
            <p >
              Smart, self-aware, and sharply written, this is a stand-up comedy show about losing your mind, raising your standards, and trying to have fun while everything is still very much falling apart.
            </p>
          </div>
        </article>

        <div className="past-shows-section">
          <h3>Past Shows</h3>

          <article className="past-show">
            <h4>Do the Robots Think I'm Funny?</h4>
            <p className="show-venue">Edinburgh Fringe 2023</p>
            <p>
              Colleen has been feeling anxius about AI. She also is worried about hecklers. Her solution? A stand-up show featuring a live AI programmed to heckle Colleen in real time. FringeReview called it "funny and unique" and noted that "the audience was riotous."
            </p>
          </article>
        </div>
      </div>
    </section>
  );
};

export default Shows;
